import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import DownloadRounded from '@mui/icons-material/DownloadRounded';
import { CircularProgress } from '@mui/material';

import ButtonPanel from 'src/components/common/ButtonPanel';
import { useShoppingCart } from 'src/components/report/ShoppingCartContext';

export const MAKE_ZIP_FIELD_TEST_ID = 'make-zip-field';

export const MakeZipField: FC = () => {
  const { downloadReportBundle, isLoading } = useShoppingCart();
  const { t } = useTranslation('report');

  return (
    <ButtonPanel
      dataTestId={MAKE_ZIP_FIELD_TEST_ID}
      onClick={downloadReportBundle}
    >
      {isLoading ? <CircularProgress /> : <DownloadRounded fontSize="large" />}

      <div>{t('shoppingCart.downloadAllReports')}</div>
    </ButtonPanel>
  );
};

export default MakeZipField;
